<!-- <div #narrative class="row hz-divider icon"></div> -->
<div class="row hz-divider icon" [innerHtml]="displayText | safeHtml"></div>
<!-- <div #narrative class="row hz-divider icon" [innerHtml]="displayText | safeHtml"></div> -->